import { createElement, useEffect, useRef } from 'react';
import clamp from './clamp';
const dotdotdot = (container, clampValue) => {
    if (!container) {
        return;
    }
    if (clampValue) {
        clamp(container, { clamp: clampValue });
    }
};
export const Dotdotdot = ({ children, clamp: clampProp, className, tagName: TagName = 'div', }) => {
    const containerRef = useRef(null);
    useEffect(() => {
        if (containerRef.current) {
            dotdotdot(containerRef.current, clampProp);
        }
    }, [clampProp]);
    return createElement(TagName, {
        className,
        ref: containerRef,
    }, children);
};
//# sourceMappingURL=Dotdotdot.js.map